import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AssetSourcePipe} from './assetSource.pipe';

@NgModule({
    declarations: [AssetSourcePipe],
    imports: [CommonModule],
    exports: [AssetSourcePipe]
})
export class AssetPipeModule
{
}